<template>
  <div v-if="visible" class="video-block">
      <AppFacade v-if="isYoutube" cookie-type="social">
        <div class="video-block__inner">
          <iframe
              :src="computedUrl"
              title="YouTube video player"
              loading="lazy"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
              class="video-block__iframe"
          />
          <small v-if="data.caption" class="video-block__small">{{ data.caption }}</small>
        </div>
      </AppFacade>
      <div v-else class="video-block__content">
        <iframe
            :src="computedUrl"
            title="YouTube video player"
            loading="lazy"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
            class="video-block__iframe"
        />
        <small v-if="data.caption" class="video-block__small">{{ data.caption }}</small>
      </div>
  </div>
</template>

<script setup lang="ts">

import {computed} from 'vue'
import {TVideoBlock} from '~/types/block-types'
import {TArchiveMediaBlock} from '~/types/block-archive-types'
import {useRuntimeConfig} from "nuxt/app";
import {isVisible} from "~/utils/visibility";
import Facade from "~/components/components/Facade.vue";

const props = defineProps<{
  data: TVideoBlock | TArchiveMediaBlock,
}>()

const visible = computed(() => {
  return isVisible(props.data)
})

const config = useRuntimeConfig()

const isYoutube = computed(() => {
  return props.data?.vendor === 'youtube'
})

const computedUrl = computed(() => {
  let result = ''
  const embedUrl = props.data?.embed_url || undefined

  if (embedUrl && embedUrl !== '') {
    // if the block provides a url, use that.
    result = embedUrl
  } else if (isYoutube.value) {
    // youtube
    result = 'https://www.youtube-nocookie.com/embed/' + props.data.source_id
  } else {
    // npo
    result = config.public.npoPlayerUrl + props.data.source_id
  }

  return result
})

</script>

<style scoped lang="postcss">
.video-block {
  position: relative;
  @mixin app-layout-container;
  @mixin app-block-margins;

  &__inner {
    grid-column: 1 / -1;

    @media (--xl) {
      grid-column: span 10 / span 10;
      grid-column-start: 2;
    }
  }

  &__iframe {
    aspect-ratio: 16 / 9;
    width: 100%;
    background-color: #000;
  }

  &__small {
    display: block;
    padding-top: 0.5rem;
    @mixin app-caption-wide;
  }

  &__content {
    position: relative;
    grid-column: 1 / -1;

    @media (--xl) {
      grid-column: span 10 / span 10;
      grid-column-start: 2;
    }
  }
}
</style>
